import { fullWidthTicketBox } from "../Help/View.fs.js";
import * as react from "react";
import { quickfinderBox } from "../QuickFinder/View.fs.js";
import { Msg } from "./Types.fs.js";
import { newsListView } from "../News/View.fs.js";
import { Page } from "../News/Types.fs.js";

export function view(model, dispatch, navigateTo) {
    let children_6, children, children_4;
    return [(children_6 = [(children = [fullWidthTicketBox((arg) => {
        navigateTo(arg);
    })], react.createElement("div", {
        className: "columns help-center",
    }, ...children)), quickfinderBox(navigateTo, (arg_1) => {
        dispatch(new Msg(2, [arg_1]));
    }, ""), newsListView(model.NewsList, (arg_2) => {
        navigateTo(arg_2);
    }, false), (children_4 = [react.createElement("a", {
        onClick: (_arg) => {
            navigateTo(new Page(0, [1]));
        },
    }, "weitere News")], react.createElement("div", {
        className: "view-more",
    }, ...children_4))], react.createElement("div", {
        className: "homepage",
    }, ...children_6))];
}

//# sourceMappingURL=View.fs.js.map
